module.exports = __webpack_public_path__ + "static/media/pegasys-teku-circle.4147bb69.png";